import { 
  Avatar, 
  Box, 
  IconButton, 
  ListItem, 
  ListItemAvatar, 
  Paper, 
  Typography,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import { dateTimeFormat } from 'utils/formater';
import { 
  Delete as DeleteIcon,
  Edit as EditIcon,
  InsertDriveFile as FileIcon,
  MoreVert as MoreVertIcon,
} from '@material-ui/icons';
import { useEffect, useState } from 'react';
import { FileViewer, Modal } from 'components';
import useStyles from './style';
import MessageEdit from '../MessageInput/MessageEdit';
import { getSignedUrl } from 'utils/aws/s3';
import { getFileType } from 'utils/files';

const MessageItem = (props) => {
  const {
    message: initialMessage, 
    permissions,
    onEdit,
    events,
    onDelete,
    setMessages,
  } = props;

  const classes = useStyles();
  const [modalState, setModalState] = useState(false);
  const [isEditMessage, setIsEditMessage] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [modal, setModal] = useState(null);
  const [message, setMessage] = useState(null);

  const handleOpenModal = (messageId) => {
    setModalState({ 
      open: true, 
      messageId,
    });
  };

  const handleCloseModal = () => {
    setModalState({ 
      open: false, 
      messageId: null,
    });
  };

  const handleDeleteClick = async () => {
    if (modalState.messageId && onDelete) {
      try {
        await onDelete(modalState.messageId);
        setMessages((prev) => prev.filter((msg) => msg.id !== modalState.messageId));
        handleCloseModal();
      } catch (error) {
        console.error('Error deleting message:', error);
      }
    }
  };

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const showModal = (data) => {
    setModal({
      open: true,
      data,
    });
  };
  
  const closeModal = () => {
    setModal(null);
  };

  useEffect(() => {
    if(initialMessage?.files?.length > 0) {
      (async () => {
        try {
          const newFiles = [];
  
          for await (const [index, file] of initialMessage.files.entries()) {
            const ext = ((file ?? '').split('.').pop() || '').toLowerCase();
            
            const signedUrl = await getSignedUrl(file, 120);
            
            const { type } = getFileType(ext);
      
            newFiles.push({
              id: `file-${Date.now()}-${index}`,
              name: 'Previsualización',
              signed: signedUrl,
              type,
              url: file,
            });
          };
    
          setMessage({
            ...initialMessage,
            files: newFiles,
          });
        } catch (error) {
          setMessage({
            ...initialMessage,
            files: [],
          });
        }
      })();
    } else {
      setMessage(initialMessage);
    }
  }, []);

  return (
    <ListItem
      className={`${classes.messageItem} ${message?.user === 'user' ? 'user' : ''} ${anchorEl ? 'menuOpen' : ''}`}
      alignItems="flex-start"
      disableGutters
    >

      <Modal
        actions={[
          {
            color: 'gray',
            fn: () => handleCloseModal(false),
            label: 'Cancelar',
          },
          {
            color: 'primary',
            fn: () => handleDeleteClick(),
            label: 'Eliminar',
          },
        ]}
        events={{
          onClose: () => handleCloseModal(false),
        }}
        open={modalState.open}
        title={'Confirmar eliminación'}
      >
        Estás seguro de que deseas eliminar su elección?
      </Modal>

      {modal?.data && (
        <FileViewer
          data={modal.data}
          onClose={() => closeModal()}
          modal={modal?.open || false}
          actions={true}
          thumbs={true}
        />
      )}

      {message?.user !== 'user' && (
        <ListItemAvatar style={{
          margin: 0,
          minWidth: '60px',
        }}>
          <Avatar className={classes.avatar}>
            {message?.user?.charAt(0)?.toUpperCase()}
          </Avatar>
        </ListItemAvatar>
      )}

      <Box style={{
        width: '100%',
      }}>
        <Box style={{
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
          gap: '8px',
        }}>
          <Typography
            variant="body1"
            style={{
              fontWeight: 'bold',
              textTransform: 'capitalize',
            }}
          >
            {message?.user}
          </Typography>
          <Typography
            variant="body2"
            className={classes.messageMeta}
          >
            {dateTimeFormat(message?.date, 'HH:mm', true)}
          </Typography>
        </Box>
        <Box style={{ 
          display: 'flex', 
          flexDirection: 'column',
          flexGrow: 1,
        }}>
          {isEditMessage ? (
            <MessageEdit
              message={message}
              onEdit={onEdit}
              events={events}
              setIsEditMessage={setIsEditMessage}
              setMessages={setMessages}
            />
          ) : (
            <Box className={classes.messageContent}>
              <Paper
                elevation={0} 
                className={`${classes.messageBubble} ${message?.user === 'user' ? 'user' : ''}`}
              >
                <Typography>
                  {message?.text}
                </Typography>
                {(permissions.edit || permissions.delete) && (
                  <Box className={classes.messageActions}>
                    {permissions.edit && onEdit && (
                      <IconButton onClick={() => setIsEditMessage(true)} style={{
                        padding: 0,
                      }}>
                        <EditIcon fontSize="small" style={{
                          marginRight: 8,
                          fontSize: 16,
                          color: 'blue',
                        }} />
                      </IconButton>
                    )}
                    {permissions.delete && onDelete && (
                      <IconButton onClick={() => handleOpenModal(message?.id)} style={{
                        padding: 0,
                      }}>
                        <DeleteIcon fontSize="small" style={{ 
                          marginRight: 8,
                          fontSize: 16,
                          color: 'red',
                        }} />
                      </IconButton>
                    )}
                    {events.length > 0 && (
                      <Box className={classes.moreOptions}>
                        <IconButton
                          onClick={handleMenuOpen}
                          style={{
                            padding: 0,
                          }}
                        >
                          <MoreVertIcon fontSize="small" />
                        </IconButton>
                        
                        <Menu
                          anchorEl={anchorEl}
                          open={Boolean(anchorEl)}
                          onClose={handleMenuClose}
                          elevation={3}
                          getContentAnchorEl={null}
                          anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right',
                          }}
                          transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                          }}
                        >
                          {events.map((event, index) => (
                            <MenuItem
                              key={index}
                              onClick={() => {
                                event.action();
                                handleMenuClose();
                              }}
                              disabled={event.disabled}
                              dense
                              className={classes.menuItem}
                            >
                              {event.icon && (
                                <ListItemIcon className={classes.listItemIcon}>
                                  {event.icon}
                                </ListItemIcon>
                              )}
                              <ListItemText 
                                primary={event.label} 
                                className={classes.listItemText}
                              />
                            </MenuItem>
                          ))}
                        </Menu>
                      </Box>
                    )}
                  </Box>
                )}
                {message?.files?.length > 0 && (
                  <Box className={classes.filesPreviewContainer}>
                    {message?.files?.map((file) => (
                      <Box 
                        key={file.id} 
                        className={classes.fileThumbnail}
                        sx={{ 
                          position: 'relative',
                          cursor: 'pointer',
                        }}
                        onClick={() => showModal(file.url)}
                      >
                        {file.type === 'image' ? (
                          <img 
                            src={file.signed} 
                            alt={file.name} 
                            className={classes.fileImage}
                          />
                        ) : (
                          <Avatar className={classes.fileDocument}>
                            <FileIcon fontSize="large" />
                          </Avatar>
                        )}
                        <Box className={classes.fileInfo}>
                          <Typography variant="caption" noWrap>
                            {file.name}
                          </Typography>
                        </Box>
                      </Box>
                    ))}
                  </Box>
                )}
              </Paper>
            </Box>
          )}
        </Box>
      </Box>

      {message?.user === 'user' && (
        <ListItemAvatar style={{ 
          marginTop: 0,
        }}>
          <Avatar className={classes.avatar}>
            {message?.user?.charAt(0).toUpperCase()}
          </Avatar>
        </ListItemAvatar>
      )}
    </ListItem>
  );
};

MessageItem.propTypes = {
  key: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  message: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    text: PropTypes.string.isRequired,
    date: PropTypes.string.isRequired,
    user: PropTypes.string.isRequired,
    files: PropTypes.array,
  }).isRequired,
  permissions: PropTypes.shape({
    edit: PropTypes.bool,
    delete: PropTypes.bool,
  }),
  onEdit: PropTypes.func,
  events: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      action: PropTypes.func.isRequired,
      icon: PropTypes.element,
      disabled: PropTypes.bool,
    }),
  ),
  onDelete: PropTypes.func,
  setMessages: PropTypes.func.isRequired,
};

MessageItem.defaultProps = {
  onEdit: null,
  events: [],
  onDelete: null,
  permissions: {
    edit: false,
    delete: false,
  },
};

export default MessageItem;
